import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Programs from './components/Programs';
import Schedule from './components/Schedule';
import Benefits from './components/Benefits';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <main>
        <Hero />
        <About />
        <Programs />
        <Schedule />
        <Benefits />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
